var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createApp } from "vue";
import GiftCardOrderApp from "./GiftCardOrderApp.vue";
import { clearDataset, extractAppData } from "../../utils";
import { useRecaptcha } from "../../components/recaptcha";
export function initGiftCardOrderApp() {
    return __awaiter(this, void 0, void 0, function* () {
        const el = document.getElementById('giftCardOrderApp');
        if (!el) {
            return;
        }
        clearDataset(el);
        const data = extractAppData(el);
        const recaptcha = yield useRecaptcha();
        createApp(GiftCardOrderApp, Object.assign(Object.assign({}, data), { recaptcha, minDate: new Date(data.minDate), maxDate: new Date(data.maxDate) })).mount(el);
    });
}
